const ABIndexCore = require("../core/ABIndexCore");
module.exports = class ABIndex extends ABIndexCore {};
